<template>
  <div class="w-full bg-white">
    <div
      class="md:p-10 p-4 md:flex md:justify-center xl:flex-1 xl:flex xl:items-center"
    >
      <form class="md:w-4/5" @submit.prevent="handleSubmit">
        <p class="text-2xl text-gray-dark italic font-semibold">
          Verification Succesful
        </p>
        <p class="text-sm py-2 mb-8 text-gray-dark italic">
          Set up profile by telling us bit about yourself.
        </p>
        <div class="flex mb-32">
          <div class="mt-4 text-gray-700 w-64 h-8">
            <LanguageInput
              :languagesList="languagesList"
              :languagesData="languagesData"
              :languages="languages"
              @LanguagesChange="handleLanguagesChange"
              @LanguagesRemove="handleLanguagesRemove"
            />
          </div>
          <div class="mt-4 text-gray-700 w-64 h-8 ml-8">
            <div v-if="categories">
              <CategoryInput
                :categoriesList="categories"
                :categoriesData="selectedCategories"
                :category_id="category"
                @CategoriesChange="handleCategoryChange"
                @CategoriesRemove="handleCategoryRemove"
              />
            </div>
          </div>
        </div>
        <div class="mt-4">
          <label class="block">
            <span class="text-gray-700 required">About Me</span>
            <textarea
              class="form-textarea mt-1 block w-full"
              rows="3"
              placeholder="Enter some long form content."
              v-model="about"
              :class="{ 'border-red-500': $v.about.$error }"
            ></textarea>
          </label>
          <div v-if="$v.about.$error">
            <small class="text-red-500" v-if="!$v.about.required">
              About is required
            </small>
            <small class="text-red-500" v-if="!$v.about.minLength">
              Must be at least 25 characters.
            </small>
          </div>
        </div>
        <div class="flex justify-end mt-6">
          <button
            type="submit"
            class="w-56 h-8 text-sm bg-green-light text-white"
          >
            Confirm
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import LanguageInput from "@/components/t-components/LanguageInput";
import CategoryInput from "@/components/t-components/CategoryInput";

export default {
  components: {
    LanguageInput,
    CategoryInput,
  },
  data() {
    return {
      language: "",
      category: "",
      isPrivate: 0,
      about: "",
      languages: [],
      categories: [],
      languagesData: [],
      selectedCategories: [],
      details: JSON.parse(localStorage.getItem("details")),
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  validations: {
    languagesData: {
      required,
    },
    isPrivate: {
      required,
    },
    about: {
      required,
      minLength: minLength(25),
    },
    selectedCategories: {
      required,
      maxLength: maxLength(4),
    },
  },
  computed: {
    ...mapGetters(["languagesList", "categoriesList"]),
  },
  methods: {
    ...mapActions([
      "trainerCompleteSignup",
      "getLanguagesList",
      "getCategoriesList",
      "signupVerification",
    ]),

    handleLanguagesChange(event) {
      const data = {
        id: event.target.value,
        text: event.target.options[event.target.options.selectedIndex].text,
      };
      if (data.id == "") {
        return;
      }
      const index = this.languagesData.findIndex((e) => e.id === data.id);
      if (index === -1) {
        this.languagesData.push(data);
        this.languages = data.id;
      }
    },

    handleLanguagesRemove(id) {
      const index = this.languagesData.findIndex((e) => e.id === id);
      if (index !== -1) {
        this.languagesData.splice(index, 1);
        this.languages = this.languagesData[0].id;
      }
    },

    handleCategoryChange(event) {
      const data = {
        id: event.target.value,
        text: event.target.options[event.target.options.selectedIndex].text,
      };
      if (data.id == "") {
        return;
      }
      const index = this.selectedCategories.findIndex((e) => e.id === data.id);
      if (index === -1) {
        this.selectedCategories.push(data);
        this.category = data.id;
      }
    },

    handleCategoryRemove(id) {
      const index = this.selectedCategories.findIndex((e) => e.id === id);
      if (index !== -1) {
        this.selectedCategories.splice(index, 1);
        this.category = this.selectedCategories[0].id;
      }
    },

    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.languagesData.$error) {
        return false;
      }
      if (this.$v.selectedCategories.$error) {
        return false;
      }
      if (this.$v.isPrivate.$error) {
        return false;
      }
      if (this.$v.about.$error) {
        return false;
      }
      var category_id = [];
      this.selectedCategories.forEach((d) => {
        category_id.push(d.id);
      });
      var language_id = [];
      this.languagesData.forEach((d) => {
        language_id.push(d.id);
      });

      const data = {
        language_id: language_id,
        description: this.about,
        category_id: category_id,
        private_cost: this.isPrivate,
      };
      await this.trainerCompleteSignup(data);
      localStorage.setItem("isCompleteSignup", true);
      this.$router.push({ name: "dashboard" });
    },
  },
  async created() {
    if (this.user && this.user.initial_update == 1) {
      this.$router.push({ name: "dashboard" });
    }

    this.signupVerification({ id: this.user.id }).then(() => {
      if (this.user && this.user.user_type == 2) {
        this.$router.push({ name: "dashboard" });
      } else {
        this.$router.push({ name: "home" });
      }
    });
    await this.getLanguagesList();
    const languages = [];
    this.languagesList.map((lan) => {
      languages.push({ name: lan.language, id: lan.id });
    });
    this.languages = languages;
    await this.getCategoriesList();
    const categories = [];
    this.categoriesList.map((cat) => {
      categories.push({ name: cat.name, id: cat.id });
    });
    this.categories = categories;
  },
};
</script>